import { getCartLabels } from '../../../../utils/getCartLabels'
import SummaryCustomFee from '../SummaryCustomFee'
import { SummaryListProps } from '../SummaryList.types'
import { unifyActiveFees } from '../SummaryList.utils'
import {
  SummaryListSubtotal,
  SummaryTotalsContainer,
  SummaryListTotal,
  SubTotalLabel,
  TotalLabel,
  FeeLabel,
  SummaryTotalContainer,
  TotalPrice,
  FeePrice,
  SubTotalPrice
} from './SummaryListTotals.style'

const SummaryListTotals = ({
  totalLabel,
  subTotal,
  total,
  subTotalLabel,
  activeFees,
  priceProps,
  labelMap,
  summary,
  summaryFieldsToDisplay,
  hasCustomFee
}: SummaryListProps) => {
  const { customFields } = summary || {}
  const unifiedActiveFees = unifyActiveFees(activeFees)

  return (
    <SummaryTotalsContainer>
      {subTotal && (
        <SummaryListSubtotal>
          {hasCustomFee ? (
            <SummaryCustomFee
              summaryFieldsToDisplay={summaryFieldsToDisplay}
              customFields={customFields}
              priceProps={priceProps}
              subTotalLabel={subTotalLabel}
              labelMap={labelMap}
            />
          ) : (
            <>
              <SummaryTotalContainer>
                <SubTotalLabel>{subTotalLabel}</SubTotalLabel>
                <SubTotalPrice value={subTotal} {...priceProps} />
              </SummaryTotalContainer>
              {unifiedActiveFees?.map((activeFee) => {
                const mapFeeLabel = activeFee.fee.type.split(' ')
                return (
                  <SummaryTotalContainer key={activeFee.fee.type}>
                    <FeeLabel>
                      {getCartLabels(mapFeeLabel, labelMap).label}
                    </FeeLabel>
                    <FeePrice value={activeFee.total} {...priceProps} />
                  </SummaryTotalContainer>
                )
              })}
            </>
          )}
        </SummaryListSubtotal>
      )}
      <SummaryListTotal>
        <TotalLabel>{totalLabel}</TotalLabel>
        <TotalPrice value={total} {...priceProps} />
      </SummaryListTotal>
    </SummaryTotalsContainer>
  )
}

export default SummaryListTotals
